import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

export const contentstackClient = new ApolloClient({
	link: new HttpLink({
		uri: `https://graphql.contentstack.com/stacks/${process.env.GATSBY_CONTENTSTACK_API_KEY}/?environment=${process.env.GATSBY_CONTENTSTACK_ENVIRONMENT}`,
		headers: {
			access_token: process.env.GATSBY_CONTENTSTACK_DELIVERY_TOKEN,
		},
	}),
	cache: new InMemoryCache(),
});
